import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CpqDatatableComponent } from './cpq-datatable/cpq-datatable.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CpqInputComponent } from './cpq-input/cpq-input.component';
import { CpqInputErrorComponent } from './cpq-input-error/cpq-input-error.component';
import { CpqListBoxComponent } from './cpq-list-box/cpq-list-box.component';
import { CpqToggleComponent } from './cpq-toggle/cpq-toggle.component';
import { RouterModule } from '@angular/router';
import { CpqMultiListBoxComponent } from './cpq-multi-list-box/cpq-multi-list-box.component';
import { CpqMultiListBoxWithSelectionComponent } from './cpq-multi-list-box-with-selection/cpq-multi-list-box-with-selection.component';
import { PipeModule } from './common/pipes/pipe.module';
import { EmailDirective } from './directives/validator/cpq-email.directive';
import { UrlDirective } from './directives/validator/cpq-url.directive';
import { ShowErrorsComponent } from './directives/validator/show-error/show-error.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { AnyDirective } from './directives/any.directive';
import { CpqBreadcrumbComponent } from './cpq-breadcrumb/cpq-breadcrumb.component';
import { CpqPermissionGroupsSelectionComponent } from './cpq-permission-groups-selection/cpq-permission-groups-selection.component';
import { CpqDatePickerComponent } from './cpq-date-picker/cpq-date-picker.component';
import { CustomMaterialModule } from '../ui-modules/custom-material.module';
import { CpqColumnSelectionDialogComponent } from './dialogs/cpq-column-selection-dialog/cpq-column-selection-dialog.component';
import { CpqFileSelectWithFileSystemComponent } from './cpq-file-select-with-filesystem/cpq-file-select-with-filesystem.component';
import { CpqFormulaBuilderComponent } from './cpq-formula-builder/cpq-formula-builder.component';
import { CpqNestedListComponent } from './cpq-nested-list/cpq-nested-list.component';
import { CpqTextareaComponent } from './cpq-textarea/cpq-textarea.component';
import { DateDirective } from './directives/validator/cpq-date.directive';
import { CtxTagBuilderComponent } from './cpq-formula-builder/ctx-tag-builder/ctx-tag-builder.component';
import { CpqMultiCheckboxWithSelectionComponent } from './cpq-multi-checkbox-with-selection/cpq-multi-checkbox-with-selection.component';
import { DragulaModule } from 'ng2-dragula';
import { TableListTagBuilderComponent } from './cpq-formula-builder/table-list-tag-builder/table-list-tag-builder.component';
import { CpqRankingDialogComponent } from './dialogs/cpq-ranking-dialog/cpq-ranking-dialog.component';
import { CpqRankingComponent } from './cpq-ranking/cpq-ranking.component';
import { PreviewDataTableComponent } from './cpq-formula-builder/table-list-tag-builder/preview-data-table/preview-data-table.component';
import { CpqAlphaNumericDirective } from './directives/validator/cpq-alpha-numeric.directive';
import { CpqRequiredDirective } from './directives/validator/cpq-required.directive';
import { CpqBlockedUserDirective } from './directives/validator/cpq-blocked-user.directive';
import { CpqScriptingCodemirrorComponent } from './cpq-scripting-codemirror/cpq-scripting-codemirror.component';
import { CpqScriptingPropertyComponent } from './cpq-scripting-codemirror/cpq-scripting-property/cpq-scripting-property.component';
import { EqualValidator } from './directives/validator/equal-validator.directive';
import { CpqSystemIdComponent } from './cpq-system-id/cpq-system-id.component';
import { CpqInfoComponent } from './cpq-info/cpq-info.component';
import { CpqIframeDialogComponent } from './dialogs/cpq-iframe-dialog/cpq-iframe-dialog.component';
import { CpqMultiListBoxWithRecursionDialogComponent } from './cpq-multi-list-box-with-recursion-dialog/cpq-multi-list-box-with-recursion-dialog.component';
import { CpqPricebookLookupDialogComponent } from './dialogs/cpq-pricebook-lookup-dialog/cpq-pricebook-lookup-dialog.component';
import { CpqProductDataTableDialogComponent } from './dialogs/cpq-product-data-table-dialog/cpq-product-data-table-dialog.component';
import { CpqButtonMenuComponent } from './cpq-button-menu/cpq-button-menu.component';
import { CpqAttributesDataTableDialogComponent } from './cpq-attributes-data-table-dialog/cpq-attributes-data-table-dialog.component';
import { NumberDirective } from './directives/validator/cpq-numbers.directive';
import { FormFooterAutosizeDirective } from './directives/cpq-form-footer-autosize.directive';
import { BackToTopDirective } from './directives/cpq-back-to-top.directive';
import { ActionButtonsComponent } from './cpq-datatable/action-buttons/action-buttons.component';
import { CpqScriptHistoryComponent } from './cpq-script-history/cpq-script-history.component';
import { ScriptHistoryDatatableComponent } from './cpq-script-history/script-history-datatable/script-history-datatable.component';
import { ScriptDetailsComponent } from './cpq-script-history/script-details/script-details.component';
import { CpqTextCompareComponent } from './cpq-text-compare/cpq-text-compare.component';
import { CpqAddNewChangeSetDialogComponent } from './dialogs/cpq-add-new-change-set-dialog/cpq-add-new-change-set-dialog.component';
import { NotFoundComponent } from './cpq-not-found/cpq-not-found.component';
import { CpqSelectComponent } from './cpq-select/cpq-select.component';
import { CpqDomainSelectComponent } from './cpq-domain-select/cpq-domain-select.component';
import { DomainService } from './common/services/domain.service';
import { CpqFileSelectComponent } from './cpq-file-select/cpq-file-select.component';
import { CpqTextareaResizerDirective } from './directives/cpq-textarea-resizer.directive';
import { CpqTranslationsComponent } from './cpq-translations/cpq-translations.component';
import { CpqNoWhiteSpaceDirective } from './directives/validator/cpq-no-white-space.directive';
import { CpqListBoxWithSelectionComponent } from './cpq-list-box-with-selection/cpq-list-box-with-selection.component';
import { CpqRadioButtonComponent } from './cpq-radio-button/cpq-radio-button.component';
import {CpqActiveClientSystemCertificateDataTableDialogComponent} from "./dialogs/cpq-system-certificate-data-table-dialog/cpq-active-client-system-certificate-data-table-dialog.component";
import { ODataApiClientService } from './common/services/odata-api-client.service';
import { CpqCustomValidator } from './directives/validator/cpq-custom-validator.directive';
import { CpqFormulaBuilderVisualizeDialogComponent } from './cpq-formula-builder/cpq-formula-builder-visualize-dialog/cpq-formula-builder-visualize-dialog.component';
import { CpqMlTranslationsComponent } from './cpq-ml-translations/cpq-ml-translations.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ElementResizeObserverService } from './common/services/element-resize-observer.service';
import { CpqCodemirrorComponent } from './cpq-codemirror/cpq-codemirror.component';
import { CpqMultiListBoxWithRecursionComponent } from './cpq-multi-list-box-with-recursion/cpq-multi-list-box-with-recursion.component';
import { CpqUsageDialogComponent } from './dialogs/cpq-usage-dialog/cpq-usage-dialog.component';
import { CpqCannotStartWithWhiteSpaceDirective } from './directives/validator/cpq-cannot-start-with-white-space.directive';
import { CpqTabsComponent } from './cpq-tabs/cpq-tabs.component';
import { TransactionIdLabelTranslationDialogComponent } from './dialogs/cpq-transaction-id-label-translation-dialog/cpq-transaction-id-label-translation-dialog.component';
import { CpqCollapsibleSectionComponent } from './cpq-collapsible-section/cpq-collapsible-section.component';
import { PopoverDirective } from './directives/cpq-popover.directive';

@NgModule({
  imports: [
    CommonModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    FormsModule,
    PipeModule,
    RouterModule,
    CustomMaterialModule,
    DragulaModule.forRoot(),
    NgxChartsModule
  ],
  declarations: [
    CpqNoWhiteSpaceDirective,
    EmailDirective,
    UrlDirective,
    DateDirective,
    FormFooterAutosizeDirective,
    BackToTopDirective,
    ShowErrorsComponent,
    CpqDatatableComponent,
    CpqInputComponent,
    CpqInputErrorComponent,
    CpqSelectComponent,
    CpqDomainSelectComponent,
    ConfirmDialogComponent,
    CpqListBoxComponent,
    CpqToggleComponent,
    AnyDirective,
    CpqMultiListBoxComponent,
    CpqMultiListBoxWithSelectionComponent,
    CpqBreadcrumbComponent,
    CpqBreadcrumbComponent,
    CpqPermissionGroupsSelectionComponent,
    CpqDatePickerComponent,
    CpqColumnSelectionDialogComponent,
    CpqFileSelectWithFileSystemComponent,
    CtxTagBuilderComponent,
    CpqFormulaBuilderComponent,
    CpqBreadcrumbComponent,
    CpqNestedListComponent,
    CpqTextareaComponent,
    CpqMultiCheckboxWithSelectionComponent,
    CpqRankingDialogComponent,
    CpqRankingComponent,
    TableListTagBuilderComponent,
    PreviewDataTableComponent,
    CpqScriptingCodemirrorComponent,
    CpqScriptingPropertyComponent,
    CpqAlphaNumericDirective,
    CpqRequiredDirective,
    CpqBlockedUserDirective,
    EqualValidator,
    CpqMultiListBoxWithRecursionComponent,
    CpqMultiListBoxWithRecursionDialogComponent,
    CpqSystemIdComponent,
    CpqInfoComponent,
    CpqIframeDialogComponent,
    CpqPricebookLookupDialogComponent,
    CpqProductDataTableDialogComponent,
    CpqActiveClientSystemCertificateDataTableDialogComponent,
    CpqButtonMenuComponent,
    CpqAttributesDataTableDialogComponent,
    NumberDirective,
    ActionButtonsComponent,
    CpqScriptHistoryComponent,
    ScriptHistoryDatatableComponent,
    ScriptDetailsComponent,
    CpqTextCompareComponent,
    CpqAddNewChangeSetDialogComponent,
    NotFoundComponent,
    CpqFileSelectComponent,
    CpqTextareaResizerDirective,
    CpqTranslationsComponent,
    CpqNoWhiteSpaceDirective,
    CpqListBoxWithSelectionComponent,
    CpqRadioButtonComponent,
    CpqCustomValidator,
    CpqFormulaBuilderVisualizeDialogComponent,
    CpqMlTranslationsComponent,
    CpqCodemirrorComponent,
    CpqUsageDialogComponent,
    CpqCannotStartWithWhiteSpaceDirective,
    CpqTabsComponent,
    TransactionIdLabelTranslationDialogComponent,
    CpqCollapsibleSectionComponent,
    PopoverDirective
  ],
  exports: [
    ShowErrorsComponent,
    CpqNoWhiteSpaceDirective,
    EmailDirective,
    UrlDirective,
    DateDirective,
    FormFooterAutosizeDirective,
    BackToTopDirective,
    CpqDatatableComponent,
    CpqInputComponent,
    CpqInputErrorComponent,
    CpqSelectComponent,
    CpqDomainSelectComponent,
    ConfirmDialogComponent,
    FormsModule,
    PipeModule,
    CpqListBoxComponent,
    CpqToggleComponent,
    CpqMultiListBoxComponent,
    CpqMultiListBoxWithSelectionComponent,
    AnyDirective,
    CpqBreadcrumbComponent,
    CpqDatePickerComponent,
    CustomMaterialModule,
    CpqFileSelectWithFileSystemComponent,
    CpqFormulaBuilderComponent,
    CpqPermissionGroupsSelectionComponent,
    CpqFileSelectWithFileSystemComponent,
    CpqNestedListComponent,
    CpqTextareaComponent,
    CpqMultiCheckboxWithSelectionComponent,
    CpqRankingDialogComponent,
    CpqRankingComponent,
    PreviewDataTableComponent,
    CpqAlphaNumericDirective,
    CpqScriptingCodemirrorComponent,
    CpqRequiredDirective,
    CpqBlockedUserDirective,
    EqualValidator,
    CpqMultiListBoxWithRecursionComponent,
    CpqMultiListBoxWithRecursionDialogComponent,
    CpqSystemIdComponent,
    CpqInfoComponent,
    CpqIframeDialogComponent,
    CpqPricebookLookupDialogComponent,
    CpqProductDataTableDialogComponent,
    CpqActiveClientSystemCertificateDataTableDialogComponent,
    CpqButtonMenuComponent,
    DragulaModule,
    CpqAttributesDataTableDialogComponent,
    NumberDirective,
    CpqScriptHistoryComponent,
    ScriptHistoryDatatableComponent,
    ScriptDetailsComponent,
    CpqTextCompareComponent,
    CpqAddNewChangeSetDialogComponent,
    NotFoundComponent,
    CpqFileSelectComponent,
    CpqTranslationsComponent,
    CpqListBoxWithSelectionComponent,
    CpqRadioButtonComponent,
    CpqCustomValidator,
    CpqMlTranslationsComponent,
    NgxChartsModule,
    CpqCannotStartWithWhiteSpaceDirective,
    CpqTabsComponent,
    TransactionIdLabelTranslationDialogComponent,
    CpqCollapsibleSectionComponent,
    PopoverDirective
  ],
  providers: [ODataApiClientService, ElementResizeObserverService, DomainService]
})
export class SharedModule { }
